export var PAGE_ERROR_I18N_COMPONENT_KEY = 'page-error';